import { MenuItem, QuangularConfig } from "quangular";
import { AppRoute } from "./core/enums/app-route.enum";
import { UserRole } from "@common/enums/UserRole";
import { environment } from "src/environments/environment";

export const menuItems: MenuItem[] = [
  { title: 'Dashboard', link: AppRoute.Dashboard, exact: false },
  {
    title: 'Portfolio', link: AppRoute.Portfolio, exact: false,
    items: [
      { title: 'Valuation Summary', link: `${AppRoute.Portfolio}/${AppRoute.Summary}`, exact: false },
      {
        title: 'Status', link: `${AppRoute.Portfolio}/${AppRoute.Status}`, exact: false,
        items: [
          { title: 'Overview', link: `${AppRoute.Portfolio}/${AppRoute.Status}/${AppRoute.Overview}`, exact: false },
          { title: 'Tear Sheets', link: `${AppRoute.Portfolio}/${AppRoute.Status}/${AppRoute.Tearsheets}`, exact: false },
          { title: 'Valuation', link: `${AppRoute.Portfolio}/${AppRoute.Status}/${AppRoute.Valuation}`, exact: false },
          { title: 'Quarterly Results', link: `${AppRoute.Portfolio}/${AppRoute.Status}/${AppRoute.QuarterlyResults}`, exact: false },
        ]
      },
      { title: 'Commitment Overview', link: `${AppRoute.Portfolio}/${AppRoute.CommitmentOverview}`, exact: false },
      { title: 'Contacts', link: `${AppRoute.Portfolio}/${AppRoute.Contacts}`, exact: false },
      { title: 'Staffing', link: `${AppRoute.Portfolio}/${AppRoute.Staffing}`, exact: false },
      { title: 'Tear Sheet Package', link: `${AppRoute.Portfolio}/${AppRoute.TearsheetPackage}`, exact: false }
    ]
  },
  { title: 'Companies', link: AppRoute.Companies, exact: false },
  { title: 'Treasury', link: AppRoute.Treasury, exact: false },
  {
    title: 'Funds', link: AppRoute.Funds, exact: false,
    items: [
      { title: 'Fund List', link: `${AppRoute.Funds}/${AppRoute.List}`, exact: false },
      { title: 'Performance Ratios', link: `${AppRoute.Funds}/${AppRoute.Editor}`, exact: false },
    ]
  },
  { title: 'Documents', link: AppRoute.Documents, exact: false },
  {
    title: 'Admin', link: AppRoute.Admin, exact: false, roles: [UserRole.Admin],
    items: [
      { title: 'Users', link: `${AppRoute.Admin}/${AppRoute.Users}`, exact: false },
      {
        title: 'System Properties', link: `${AppRoute.Admin}/${AppRoute.SystemProperties}`, exact: false,
        items: [
          { title: 'Document Type', link: `${AppRoute.Admin}/${AppRoute.SystemProperties}/${AppRoute.Document}`, exact: false },
          { title: 'Generate Workflow', link: `${AppRoute.Admin}/${AppRoute.SystemProperties}/${AppRoute.GenerateWorkflow}`, exact: false },
        ]
      },
      { title: 'Reconciliation', link: `${AppRoute.Admin}/${AppRoute.Reconciliation}`, exact: false },
      { title: 'Activity Logs', link: `${AppRoute.Admin}/${AppRoute.ActivityLogs}`, exact: false },
    ]
  },
];

export const config: QuangularConfig = {
  environment: environment,
  appRoles: [UserRole.User, UserRole.Admin, UserRole.Reader, UserRole.DocusignIntegration, UserRole.Treasury],
  mainMenu: menuItems,
  roleRoutes: {
    [UserRole.User]: [AppRoute.Dashboard, AppRoute.Portfolio, AppRoute.Companies, AppRoute.Treasury, AppRoute.Funds, AppRoute.Documents, AppRoute.User, AppRoute.FundFlow],
    [UserRole.Admin]: [AppRoute.Dashboard, AppRoute.Portfolio, AppRoute.Companies, AppRoute.Treasury, AppRoute.Funds, AppRoute.Documents, AppRoute.User, AppRoute.FundFlow, AppRoute.Admin],
    [UserRole.Reader]: [AppRoute.Dashboard, AppRoute.Portfolio, AppRoute.Companies, AppRoute.Treasury, AppRoute.Funds, AppRoute.Documents, AppRoute.User, AppRoute.FundFlow],
    [UserRole.DocusignIntegration]: [AppRoute.Dashboard, AppRoute.Portfolio, AppRoute.Companies, AppRoute.Treasury, AppRoute.Funds, AppRoute.Documents, AppRoute.User, AppRoute.FundFlow],
    [UserRole.Treasury]: [AppRoute.Dashboard, AppRoute.Portfolio, AppRoute.Companies, AppRoute.Treasury, AppRoute.Funds, AppRoute.Documents, AppRoute.User, AppRoute.FundFlow],
  }
};
